export default __webpack_public_path__ + "static/media/close.ddfe7fa2.svg";